// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_cfwr5 {
    width: 100%;
    padding: var( --size-padLarge );
    border-top: 1px solid var(--color-base100);
    background-color: var( --color-base025 );
}

.area_mpBRf {
    border-radius: var( --size-padMedium );
    border: 1px solid var( --color-base100 );
    padding: var( --size-padMedium );
    margin-bottom: var( --size-padMedium);
    background-color: var( --color-base050 );
}

.header_odveC {
    padding-bottom: var( --size-padMedium );
  }

.borderTop_pLkgU {
    border-top: 1px solid var(--color-base100);
    padding-top: var(--size-padLarge);
    margin: var(--size-padMedium) 0 0;
}

.paddingTop_f2hw5 {
    padding-top: var(--size-padMedium);
}

.disabled_OxUEX {
    opacity: .5;
}

/*
.pane {
    border-top: 1px solid var(--color-base100)
}

.label {
    display: flex;
    align-items: center;
}
.rowGrid {
    align-items: center;
    display : grid;
    grid-template-columns: 100px 40px 160px 160px;
    column-gap: 16px;
    overflow: visible !important;
    height: 48px;
    padding: var( --size-padSmall ) var( --size-padMedium );
  }

  
.picker :global( .rw-popup .rw-list ) {
    max-height: 120px;
}
  
.header {
    padding-bottom: var( --size-padMedium );
}
  
.area {
    border-radius: var( --size-padMedium );
    border: 1px solid var( --color-base100 );
}
  
.area > .rowGrid:nth-child(even) {
    background-color: var( --color-base025 );
}
  
.area > .rowGrid:nth-child(odd) {
    background-color: var( --color-detailOddRow );
}
  
.area > .rowGrid.disabled {
    background-color: var( --color-base050 );
}
  
.borderTop {
    border-top: 1px solid var(--color-base100);
    padding: var(--size-padLarge) 0;
    margin: var(--size-padLarge) 0 0;
}
  
.tzLabel {
    flex: 0 0 220px;
}
  
.tzSelector {
    flex-grow: 1;
}*/`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/dashboard/viewer/location/SimOTACard.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,+BAA+B;IAC/B,0CAA0C;IAC1C,wCAAwC;AAC5C;;AAEA;IACI,sCAAsC;IACtC,wCAAwC;IACxC,gCAAgC;IAChC,qCAAqC;IACrC,wCAAwC;AAC5C;;AAEA;IACI,uCAAuC;EACzC;;AAEF;IACI,0CAA0C;IAC1C,iCAAiC;IACjC,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,WAAW;AACf;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAyDE","sourcesContent":[".content {\n    width: 100%;\n    padding: var( --size-padLarge );\n    border-top: 1px solid var(--color-base100);\n    background-color: var( --color-base025 );\n}\n\n.area {\n    border-radius: var( --size-padMedium );\n    border: 1px solid var( --color-base100 );\n    padding: var( --size-padMedium );\n    margin-bottom: var( --size-padMedium);\n    background-color: var( --color-base050 );\n}\n\n.header {\n    padding-bottom: var( --size-padMedium );\n  }\n\n.borderTop {\n    border-top: 1px solid var(--color-base100);\n    padding-top: var(--size-padLarge);\n    margin: var(--size-padMedium) 0 0;\n}\n\n.paddingTop {\n    padding-top: var(--size-padMedium);\n}\n\n.disabled {\n    opacity: .5;\n}\n\n/*\n.pane {\n    border-top: 1px solid var(--color-base100)\n}\n\n.label {\n    display: flex;\n    align-items: center;\n}\n.rowGrid {\n    align-items: center;\n    display : grid;\n    grid-template-columns: 100px 40px 160px 160px;\n    column-gap: 16px;\n    overflow: visible !important;\n    height: 48px;\n    padding: var( --size-padSmall ) var( --size-padMedium );\n  }\n\n  \n.picker :global( .rw-popup .rw-list ) {\n    max-height: 120px;\n}\n  \n.header {\n    padding-bottom: var( --size-padMedium );\n}\n  \n.area {\n    border-radius: var( --size-padMedium );\n    border: 1px solid var( --color-base100 );\n}\n  \n.area > .rowGrid:nth-child(even) {\n    background-color: var( --color-base025 );\n}\n  \n.area > .rowGrid:nth-child(odd) {\n    background-color: var( --color-detailOddRow );\n}\n  \n.area > .rowGrid.disabled {\n    background-color: var( --color-base050 );\n}\n  \n.borderTop {\n    border-top: 1px solid var(--color-base100);\n    padding: var(--size-padLarge) 0;\n    margin: var(--size-padLarge) 0 0;\n}\n  \n.tzLabel {\n    flex: 0 0 220px;\n}\n  \n.tzSelector {\n    flex-grow: 1;\n}*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_cfwr5`,
	"area": `area_mpBRf`,
	"header": `header_odveC`,
	"borderTop": `borderTop_pLkgU`,
	"paddingTop": `paddingTop_f2hw5`,
	"disabled": `disabled_OxUEX`
};
export default ___CSS_LOADER_EXPORT___;
